// import logo from './logo.svg';
import Home from "./Home";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NewsEvents from "./Pages/NewsEvents";
import InitiativePage from "./Pages/Initiatives";
import Team from "./Pages/MeetTheTeam";
import AICoEShowcase from "./Pages/AICOE";
import KQAICADMoUBlogPost from "./Pages/news/KQAICADMoU";
import GeoAISeminar from "./Pages/news/GeoAISeminar";
import Header from "./components/Header";

function App() {
  return (
      <Router>
          <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/news-and-events" element={<NewsEvents/>} />
            <Route path="/initiatives" element={<InitiativePage />} />
            <Route path="/ai-coe" element={<AICoEShowcase />} />
            <Route path="/news/kenya-airways-aicad-mou-digital-skills-innovation" element={<KQAICADMoUBlogPost />} />
            <Route path="/news/geoai-seminar-2026" element={<GeoAISeminar />} />
        </Routes>
      </Router>
  );
}

export default App;
